import React from 'react';
import OverlayLayer from './OverlayLayer.jsx';

// Renders AI-identified regions (bounding boxes with labels).
// Color-coded by kind.
const COLORS = {
  fracture_suspect: '#f87171',
  hardware:         '#60a5fa',
  lesion:           '#fbbf24',
  oa_severity:      '#2dd4a0',
  default:          '#a78bfa',
};

export default function AIRegionsOverlay({
  regions = [],
  imageWidth, imageHeight,
  canvasWidth, canvasHeight,
  panX, panY, zoom, rotation,
  minConfidence = 0.4,
}) {
  if (!regions || regions.length === 0) return null;
  const shown = regions.filter(r => (r.confidence ?? 1) >= minConfidence && Array.isArray(r.bbox) && r.bbox.length === 4);

  const overlayProps = { imageWidth, imageHeight, canvasWidth, canvasHeight, panX, panY, zoom, rotation };
  const sw = Math.max(0.5, 2 / Math.max(0.1, (Math.min(canvasWidth / imageWidth, canvasHeight / imageHeight) * zoom)));
  const textSize = Math.max(8, 13 / Math.max(0.1, (Math.min(canvasWidth / imageWidth, canvasHeight / imageHeight) * zoom)));

  return (
    <OverlayLayer {...overlayProps} interactive={false}>
      {shown.map((r, i) => {
        const [x, y, w, h] = r.bbox;
        const color = COLORS[r.kind] || COLORS.default;
        const label = `${r.kind} · ${Math.round((r.confidence || 0) * 100)}%${r.label ? ' · ' + r.label : ''}`;
        return (
          <g key={i}>
            <rect x={x} y={y} width={w} height={h} fill="none" stroke={color} strokeWidth={sw} strokeDasharray={`${sw * 3} ${sw * 2}`} />
            <rect x={x} y={y - textSize - sw * 2} width={label.length * textSize * 0.56} height={textSize + sw * 2} fill={color} opacity="0.9" />
            <text x={x + sw * 2} y={y - sw * 1} fill="#0b1410" fontSize={textSize} fontFamily="'JetBrains Mono', monospace">
              {label}
            </text>
          </g>
        );
      })}
    </OverlayLayer>
  );
}
